import { PageHeader } from 'antd'
import * as React from 'react'
import { Dashboard } from '../dashboard/Dashboard'
import { YearPicker } from './YearPicker'

interface TabDashboardProps {
    clienteId: string
}

class TabDashboardState {
    Anno: number = 2021
}

export class TabDashboard extends React.Component<TabDashboardProps, TabDashboardState> {
    constructor(props) {
        super(props)
        this.state = new TabDashboardState()
    }

    renderYears = () => {
        return <YearPicker clienteId={this.props.clienteId} onAnnoChange={value => this.setState({ Anno: value })} />
    }

    render() {
        return (
            <PageHeader title="Dashboard" extra={this.renderYears()}>
                <Dashboard anno={this.state.Anno} cliente={this.props.clienteId} />
            </PageHeader>
        )
    }
}